export default __webpack_public_path__ + "static/media/loot-box.008b9c37.svg";